import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product GM Part Number.
 * This component listens for variant update events and updates the display accordingly.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} gmPartNumberContainer - The container element for the GM Part Number
 * @property {HTMLElement} gmPartNumber - The span element that displays the GM Part Number text
 *
 * @extends {Component<Refs>}
 */
class ProductGmPartNumberComponent extends Component {
  requiredRefs = ['gmPartNumberContainer', 'gmPartNumber'];

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateGmPartNumber);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateGmPartNumber);
  }

  /**
   * Updates the GM Part Number.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateGmPartNumber = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    if (event.detail.resource) {
      const gmPartNumber = event.detail.resource.gm_part_number || '';

      if (gmPartNumber) {
        this.style.display = 'block';
        this.refs.gmPartNumber.textContent = gmPartNumber;
      } else {
        this.style.display = 'none';
        this.refs.gmPartNumber.textContent = '';
      }
    }
  };
}

if (!customElements.get('product-gm-part-number-component')) {
  customElements.define('product-gm-part-number-component', ProductGmPartNumberComponent);
}
